import { render, staticRenderFns } from "./DashboardSearch.vue?vue&type=template&id=a813b672&scoped=true"
import script from "./DashboardSearch.vue?vue&type=script&lang=js"
export * from "./DashboardSearch.vue?vue&type=script&lang=js"
import style0 from "./DashboardSearch.vue?vue&type=style&index=0&id=a813b672&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a813b672",
  null
  
)

export default component.exports